import { Button, Grid2 } from '@mui/material'
import React from 'react'
import { Link as ReactRouterLink, useHistory, useLocation, useParams } from 'react-router-dom'
import CommonPageWrapper from '../../../common/components/CommonPageWrapper'
import Loader from '../../../common/loader/Loader'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index/index'
import {
  fetchExpressCheckoutMenuByStationId,
  fetchExpressCheckoutNewExceptionalScheduleWithBasis,
} from '../expressCheckoutQueries'
import { RestaurantCategorySchedule, RestaurantMenu } from '../types'
import { ExpressCheckoutScheduleForm } from './ExpressCheckoutScheduleForm'

export function NewScheduleFormPage() {
  const { stationId } = useParams<{ stationId: string }>()
  const history = useHistory()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const fromScheduleId = queryParams.get('fromScheduleId')
  return (
    <CommonPageWrapper title={i18n.t('restaurantMenu.createScheduleTitle')}>
      <Grid2 container direction='row' justifyContent='left'>
        <Grid2>
          <Button component={ReactRouterLink} variant='outlined' to={`/pikakassa/${stationId}/poikkeusaukioloajat`}>
            {i18n.t('buttons.back')}
          </Button>
        </Grid2>
      </Grid2>
      {!fromScheduleId && (
        <Query<
          { expressCheckoutMenu?: RestaurantMenu; expressCheckoutSchedules?: RestaurantCategorySchedule[] },
          { stationId: string }
        >
          query={fetchExpressCheckoutMenuByStationId}
          variables={{ stationId: decodeURIComponent(stationId) }}
        >
          {({ loading, data }) => (
            <Loader loading={loading}>
              <ExpressCheckoutScheduleForm
                stationId={stationId}
                menu={data.expressCheckoutMenu}
                existingSchedules={data.expressCheckoutSchedules}
                onCompleted={() => history.push(`/pikakassa/${stationId}/poikkeusaukioloajat`)}
              />
            </Loader>
          )}
        </Query>
      )}
      {fromScheduleId && (
        <Query<
          {
            expressCheckoutMenu?: RestaurantMenu
            expressCheckoutSchedule?: RestaurantCategorySchedule
            expressCheckoutSchedules?: RestaurantCategorySchedule[]
          },
          { stationId: string; fromScheduleId: string }
        >
          query={fetchExpressCheckoutNewExceptionalScheduleWithBasis}
          variables={{ stationId: decodeURIComponent(stationId), fromScheduleId: decodeURIComponent(fromScheduleId) }}
        >
          {({ loading, data }) => (
            <Loader loading={loading}>
              <ExpressCheckoutScheduleForm
                stationId={stationId}
                menu={data.expressCheckoutMenu}
                scheduleToBeCopied={data.expressCheckoutSchedule}
                existingSchedules={data.expressCheckoutSchedules}
                onCompleted={() => history.push(`/pikakassa/${stationId}/poikkeusaukioloajat`)}
              />
            </Loader>
          )}
        </Query>
      )}
    </CommonPageWrapper>
  )
}
